import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { first, firstValueFrom } from 'rxjs';
import { FeaturesFlagsV2Service } from 'src/app/core/services/features-flags-v2.service';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import { UserDataService } from 'src/app/core/services/user-data.service';

@Injectable({
  providedIn: 'root',
})
export class PmoDashboardGuardService {
  constructor(
    private userDataService: UserDataService,
    private permissionsService: PermissionsService,
    private router: Router,
    private featuresFlagsV2Service: FeaturesFlagsV2Service,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    await firstValueFrom(this.featuresFlagsV2Service.featuresFlags$.pipe(first((flags) => flags.length > 0)));

    if (!this.userDataService.company?.serviceAddons.includes('project-services')) {
      this.router.navigateByUrl(`/secured/cross-selling/project-services`);
      return false;
    }

    if (!this.permissionsService.hasAddonAccess('project-services')) {
      this.router.navigateByUrl(`/secured/forbidden/project-services`);
      return false;
    }
    return true;
  }
}
